import React from 'react';

export interface JSLogoProps {
  size: number;
  fill: string;
}

export function JSLogo({ size, fill }: JSLogoProps) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={fill}
      viewBox={`0 0 225.000000 225.000000`}
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M295 2075 c-51 -18 -111 -82 -125 -133 -7 -28 -10 -286 -8 -840 l3
          -798 28 -42 c15 -23 46 -54 69 -69 l42 -28 798 -3 c567 -2 811 1 841 9 52 14
          122 83 136 136 15 54 15 1584 0 1638 -15 52 -82 119 -134 134 -28 8 -280 11
          -825 11 -651 -1 -792 -3 -825 -15z m910 -1230 c0 -351 -1 -361 -22 -401 -74
          -139 -281 -178 -423 -79 -42 29 -95 99 -86 113 6 10 123 82 133 82 3 0 20 -16
          37 -35 36 -41 77 -55 124 -43 59 16 62 36 62 403 l0 326 88 -3 87 -3 0 -360z
          m563 339 c49 -24 112 -86 112 -109 0 -6 -30 -30 -66 -53 l-65 -42 -33 35 c-32
          34 -53 40 -111 36 -34 -3 -68 -50 -61 -84 9 -46 22 -55 151 -117 179 -84 232
          -141 242 -259 7 -77 -11 -135 -58 -186 -61 -67 -123 -89 -244 -90 -89 0 -107
          3 -163 29 -42 20 -79 47 -112 83 -28 30 -50 58 -50 63 0 5 32 27 72 50 l72 41
          30 -34 c48 -54 80 -70 146 -71 94 -1 150 55 119 120 -11 23 -42 43 -146 94
          -73 36 -146 78 -162 94 -99 95 -103 261 -11 354 52 52 105 70 206 71 67 1 88
          -3 132 -25z"
          fill={fill}
        />
      </g>
    </svg>
  );
}
